





























import Vue from 'vue';
import Component from 'vue-class-component';
import { db } from '@/plugins/firebase';
import { Project, IRect } from '@/types';
import { Entry } from '@/types';
import { getModule } from 'vuex-module-decorators';
import Transcription from '@/store/modules/transcription';
import firebase from '@/plugins/firebase';
import store from '@/store/store';
import { Watch } from 'vue-property-decorator';
import DictEntryDialog from '@/components/transcription/DictEntryDialog.vue';
import { IRectData } from '../../types';
import AnnotationDialog from './AnnotationDialog.vue';
import TaggingDialog from './TaggingDialog.vue';
import Auth from '@/store/modules/auth';
import { auth } from 'firebase';
import PredictDialog from './PredictDialog.vue';

const trscModule = getModule(Transcription, store);
const authModule = getModule(Auth, store);
enum Mode {
  default,
  annotation,
  predict,
  dictEntry,
  tagging,
}

@Component({
  components: {
    DictEntryDialog,
    AnnotationDialog,
    PredictDialog,
    TaggingDialog,
  },
})
export default class OpenSeaDragon extends Vue {
  viewer: any;
  selection: any;
  mode = Mode.default;
  selectedRectData: IRectData = {
    text: '',
    entryId: '',
    uid: '',
    isTemp: true,
    index: 0,
    transcriptionId: '',
    rect: {
      x: 0,
      y: 0,
      rotation: 0,
      width: 0,
      height: 0,
      url: '',
      transcriptionId: '',
    },
  };
  annotationDialog = false;
  predictDialog = false;
  dictEntryDialog = false;
  taggingDialog = false;

  get entry() {
    return trscModule.entry;
  }

  get status() {
    return trscModule.currentTranscription.status;
  }

  get currentUser() {
    return authModule.user;
  }

  get isCurrentUserEditing(): boolean {
    return trscModule.isCurrentUserEditing;
  }

  get isEditable(): boolean {
    return trscModule.isEditable;
  }

  mounted() {
    store.subscribe((mutation, state) => {
      if (
        mutation.type == 'vuexfire/ARRAY_ADD' ||
        mutation.type == 'vuexfire/ARRAY_REMOVE'
      ) {
        setTimeout(() => {
          this.drawRects();
        }, 500);
      }
    });
    const tippy = (<any>window).tippy;
    tippy('#viewer-btn-hand', {
      content: this.$t('trsc.normal'),
      placement: 'top',
    });
    tippy('#viewer-btn-write', {
      content: this.$t('trsc.embed'),
      placement: 'top',
    });
    tippy('#viewer-btn-predict', {
      content: this.$t('trsc.ai'),
      placement: 'top',
    });
    // tippy('#viewer-btn-dict', {
    //   content: '画像を辞典に登録',
    //   placement: 'top',
    // });
    // tippy('#viewer-btn-tagging', {
    //   content: '画像をタグ付け',
    //   placement: 'top',
    // });
  }

  @Watch('$route.params.page')
  onPageChange() {
    const index = parseInt(this.$route.params.page) - 1;
    this.viewer.goToPage(index);
    setTimeout(() => this.drawRects(), 500);
  }

  @Watch('entry')
  setupViewer() {
    const tileSources = this.entry.canvases.map((c: any) => {
      let info = c.images[0].resource.service['@id'];
      return info + '/info.json';
    });
    this.viewer = (<any>window).OpenSeadragon({
      id: 'osd-viewer',
      sequenceMode: true,
      showNavigationControl: true,
      showNavigator: false,
      showSequenceControl: false,
      showRotationControl: true,
      prefixUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/openseadragon/2.4.0/images/',
      tileSources: tileSources,
    });
    // disable keyboard shourtcuts
    this.viewer.innerTracker.keyHandler = null;
    this.selection = this.viewer.selection({
      prefixUrl: '/img/osd/',
      onSelection: (data: any) => {
        this.selectedRectData = {
          rect: this.buildRect(data),
          entryId: trscModule.currentTranscription.entryId,
          index: trscModule.currentTranscription.index,
          transcriptionId: trscModule.transcription.id,
          uid: authModule.user.uid,
          isTemp: true,
          text: '',
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        };
        this.openDialog();
        this.drawRects();
      },
    });
    // rotate overlays
    const updateOverlays = () => {
      this.viewer.currentOverlays.forEach((overlay: any) => {
        let rotation = parseFloat(overlay.element.getAttribute('rotation'));
        if (rotation != 0)
          overlay.element.style.transform = `rotate(${rotation * 50}deg)`;
      });
    };
    this.viewer.addHandler('update-viewport', () => {
      setTimeout(updateOverlays, 1);
    });
    this.viewer.addHandler('animation', updateOverlays);
    this.onPageChange();
    this.drawRects();
  }

  openDialog() {
    switch (this.mode) {
      case Mode.default:
        this.annotationDialog = true;
        break;
      case Mode.predict:
        this.predictDialog = true;
        break;
      case Mode.annotation:
        this.annotationDialog = true;
        break;
      case Mode.dictEntry:
        this.dictEntryDialog = true;
        break;
      case Mode.tagging:
        this.taggingDialog = true;
        break;
    }
  }

  buildRect(data: any): IRect {
    let url = '';
    const index = trscModule.currentTranscription.index;
    const base = this.entry.canvases[index].images[0].resource.service['@id'];
    const r = data;
    url = base + `/${r.x},${r.y},${r.width},${r.height}/100,/0/default.jpg`;
    const entryId = trscModule.currentTranscription.entryId;
    const transcriptionId = trscModule.transcription.id;
    return {
      url,
      transcriptionId,
      x: data.x,
      y: data.y,
      width: data.width,
      height: data.height,
      rotation: data.rotation,
    };
  }

  @Watch('trscModule.transcriptionId')
  drawRects() {
    if (this.viewer) this.viewer.clearOverlays();
    let rectDataList: IRectData[] = [];
    switch (this.mode) {
      case Mode.default:
        rectDataList = trscModule.annotations;
        break;
      case Mode.predict:
        rectDataList = [];
        break;
      case Mode.annotation:
        rectDataList = trscModule.annotations;
        break;
      default:
        rectDataList = trscModule.annotations;
        rectDataList = [];
    }
    rectDataList.forEach((data) => {
      const el = document.createElement('div');
      el.className = 'filter';
      el.setAttribute('rotation', data.rect.rotation + '');
      el.addEventListener('click', () => {
        //console.log(data);
        this.selectedRectData = data;
        this.openDialog();
      });
      (<any>window).tippy(el, { content: data.text.replace(/(?:\r\n|\r|\n)/g, '<br>'), placement: 'right' });
      this.viewer.addOverlay({
        element: el,
        px: data.rect.x,
        py: data.rect.y,
        width: data.rect.width,
        height: data.rect.height,
      });
    });
  }
  onToggleChange() {
    if (this.mode == 0) {
      this.selection.disable();
    } else {
      this.selection.enable();
    }
    this.drawRects();
  }
}
